import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { PublicHttpClientService } from "./http-client.service";

@Injectable()
export class PublicWebhooksService {
  constructor(private publicHttp: PublicHttpClientService) {}

  public scrappingCurpInfo(curp): Observable<any> {
    const params = { curp };
    return this.publicHttp
      .post("/api/webhooks/scrapping_curp_info", params)
      .pipe(tap((_) => console.log("PublicWebhooksService.scrappingCurpInfo: Ok.")));
  }
}
